import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { BellRing } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { fmtMoney, fmtDateTime } from "@/lib/format";

export const useManualReview = (enabled, notify = false, refreshKey = 0) => {
  const [items, setItems] = useState([]);
  const prev = useRef(null);
  useEffect(() => {
    if (!enabled) return undefined;
    const load = () => api.get("/manual-review").then(({ data }) => {
      const known = prev.current;
      if (notify && known) {
        const fresh = data.filter((c) => !known.has(c.id));
        if (fresh.length) toast.info(`Nuevo cobro con enlace manual de ${fresh[0].created_by}`, { description: "Revísalo en Reservaciones y cobros para marcarlo como pagado." });
      }
      prev.current = new Set(data.map((c) => c.id));
      setItems(data);
    }).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => { clearInterval(t); };
  }, [enabled, notify, refreshKey]);
  return items;
};

export const ManualReviewPanel = ({ items, onOpen }) => {
  if (!items.length) return null;
  return (
    <div className="mb-6 rounded-2xl border border-amber-200 bg-amber-50/70 p-5" data-testid="manual-review-panel">
      <div className="mb-3 flex items-center gap-2 text-amber-900">
        <BellRing size={18} />
        <p className="font-semibold">Pagos manuales por revisar ({items.length})</p>
      </div>
      <p className="mb-4 text-sm text-amber-800">Cobros con enlace manual creados por managers o cajeros. Verifica el pago en el proveedor y márcalo como pagado.</p>
      <div className="divide-y divide-amber-200/70 overflow-hidden rounded-xl border border-amber-200 bg-white">
        {items.map((c) => (
          <div key={c.id} className="flex flex-wrap items-center gap-3 px-4 py-3 text-sm" data-testid={`manual-review-item-${c.id}`}>
            <div className="min-w-[160px] flex-1">
              <p className="font-semibold text-slate-900">{c.guest_name || "Sin nombre"}</p>
              <p className="text-xs text-slate-500">{c.created_by} · {fmtDateTime(c.created_at)}</p>
            </div>
            <span className="font-mono font-semibold text-slate-900">{fmtMoney(c.amount_cents, c.currency)}</span>
            <Button size="sm" variant="outline" onClick={() => onOpen(c.id)} data-testid={`manual-review-open-${c.id}`}>Revisar</Button>
          </div>
        ))}
      </div>
    </div>
  );
};
